import { useState } from 'react'
import styles from './StartProject.module.scss'
import Layout from '../../components/layout/Layout'
import { PortfolioAppbar } from '../../components/appbar/Appbar'
import { Footer } from '../../components/footer/Footer'
import { sendContactForm } from '../../lib/api'
import Overlay from '../../components/overlay/Overlay'

export default function StartProject() {
    const [isLoading, setIsLoading] = useState(false);
    const [overlay, setOverlay] = useState({
        open: false,
        title: '',
        message: ''
    });
    const [errors, setErrors] = useState({
        email: '',
        phone: ''
    });

    const handleCloseOverlay = () => {
        setOverlay({ ...overlay, open: false });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        // Reset errors
        const newErrors = { email: '', phone: '' };
        let hasError = false;

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!data.email) {
            newErrors.email = 'Email is required';
            hasError = true;
        } else if (!emailRegex.test(data.email)) {
            newErrors.email = 'Please enter a valid email address (e.g., name@example.com)';
            hasError = true;
        }

        // Phone validation
        if (data.phone && data.phone.replace(/\D/g, '').length < 10) {
            newErrors.phone = 'Phone number must be at least 10 digits';
            hasError = true;
        }

        setErrors(newErrors);
        if (hasError) return;

        setIsLoading(true);

        try {
            await sendContactForm(data);
            setOverlay({
                open: true,
                title: "Thank You!",
                message: "We have received your message and will get back to you shortly."
            });
            e.target.reset();
            setErrors({ email: '', phone: '' });
        } catch (error) {
            console.error("Form submission error:", error);

            // Check for server-side validation error specifically for phone
            if (error.response?.data?.error?.includes('phone')) {
                setErrors(prev => ({ ...prev, phone: 'Phone number must be at least 10 digits' }));
                setIsLoading(false);
                return;
            }

            const message = "Failed to send message. Please try again.";
            setOverlay({
                open: true,
                title: "Error",
                message: message
            });
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <Layout appBar={<PortfolioAppbar />} footer={<Footer type={2} />}>
            <section className={styles.container}>
                <form method='post' onSubmit={handleSubmit}>
                    <h4>Shared thoughts will make us great again!</h4>
                    <div className={styles.wrapper}>
                        <div className={styles.field}>
                            <label htmlFor="firstName">first name</label>
                            <input id="firstName" name="firstName" placeholder='Yusuf Babatunde' required />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="lastName">last name</label>
                            <input id="lastName" name="lastName" placeholder='Adio' required />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="country">country</label>
                            <input id="country" name="country" placeholder='Nigeria' />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="address">address</label>
                            <input id="address" name="address" placeholder='Typing...' />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="phone">phone no.</label>
                            <input id="phone" name="phone" placeholder='+2347069360311' />
                            {errors.phone && <span className={styles.errorMessage}>{errors.phone}</span>}
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="email">email</label>
                            <input id="email" name="email" type="email" placeholder='contact@hardbaymedia.net' required />
                            {errors.email && <span className={styles.errorMessage}>{errors.email}</span>}
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="company">company</label>
                            <input id="company" name="company" placeholder='Small (1-5 Members)' />
                        </div>
                        <div className={styles.field}>
                            <label htmlFor="projectType">project type</label>
                            <input id="projectType" name="ProjectType" placeholder='Product Design' />
                        </div>
                        <div className={styles.field}>
                            <label className={styles.lf} htmlFor="brief">brief</label>
                            <textarea id="brief" name="message" placeholder='Type something…'></textarea>
                        </div>
                        <div className={styles.buttonField}>
                            <button type='submit' disabled={isLoading}>
                                {isLoading ? <span className={styles.loader}></span> : 'SUBMIT'}
                            </button>
                        </div>
                    </div>
                </form>
            </section>
            <Overlay
                isOpen={overlay.open}
                onClose={handleCloseOverlay}
                title={overlay.title}
                message={overlay.message}
            />
        </Layout>
    )
}
